module.exports = __webpack_public_path__ + "static/media/ng.471de819.png";